import { getPercentToGaleAvgData, getPercentToRegionData } from '../../../constants/utils';
import { pivot_config, pivot_config_region_comp } from '../../../data/overallPerformanceData';

export const checkForGlobalObject = (object) => {
  if (object === null || object === undefined) {
    return false; // Return false if object is null or undefined
  }
  return (
    Object.values(object).every((value) => value === null || value === undefined) ||
    Object.values(object).some((value) => value === null || value === undefined)
  );
};
const formatValue = (value) => {
  if (!value || value === 'NA') {
    return 'N/A';
  }
  return value.toFixed(2);
};

const getPercentToPlanValue = (comparedFiltersData, itemLabel) => {
  if (itemLabel === 'Spend' && comparedFiltersData?.spend_comp_to_plan?.current !== undefined) {
    return formatValue(comparedFiltersData.spend_comp_to_plan.current);
  } else if (
    itemLabel === 'Opportunities Generated' &&
    comparedFiltersData?.opps_comp_to_plan?.current !== undefined
  ) {
    return formatValue(comparedFiltersData.opps_comp_to_plan.current);
  } else if (
    itemLabel === 'Cost per Opportunity' &&
    comparedFiltersData?.cpo_comp_to_plan?.current !== undefined
  ) {
    return formatValue(comparedFiltersData.cpo_comp_to_plan.current);
  }
  return 'N/A';
};

export const configureRowsHandler = (comparedFiltersData) => {
  let data = [];
  if (comparedFiltersData) {
    data = {
      store_id: comparedFiltersData?.store_id || '',
      region_id: comparedFiltersData?.region_id || '',
      rows: [
        ...pivot_config.measuredResult.map((item) => ({
          columnName: 'Measured Result',
          viewData: item.label,
          total:
            comparedFiltersData[item.value]?.current !== undefined
              ? formatValue(comparedFiltersData[item.value].current)
              : 'N/A',
          percentToPlan: getPercentToPlanValue(comparedFiltersData, item.label),
          percentToPrevYear:
            comparedFiltersData[item.value]?.compare_perc !== undefined
              ? formatValue(comparedFiltersData[item.value].compare_perc)
              : 'N/A',
        })),
        ...pivot_config.calculatedPerformanceIndicators.map((item) => ({
          columnName: ' Calculated Performance Indicators',
          viewData: item.label,
          total:
            comparedFiltersData[item.value]?.current !== undefined
              ? formatValue(comparedFiltersData[item.value].current)
              : 'N/A',
          percentToPlan: getPercentToPlanValue(comparedFiltersData, item.label),
          percentToPrevYear:
            comparedFiltersData[item.value]?.compare_perc !== undefined
              ? formatValue(comparedFiltersData[item.value].compare_perc)
              : 'N/A',
        })),
      ],
    };
  }
  return data;
};

export const configureRowsRegionHandler = (regionCompDataObj) => {
  let data = [];
  if (regionCompDataObj) {
    data = {
      store_id: regionCompDataObj?.store_id,
      rows: [
        ...pivot_config_region_comp.measuredResult.map((item) => ({
          columnName: 'Measured Result',
          viewData: item.label,
          total: regionCompDataObj[item.value]?.toFixed(2) || 'N/A',
          percentToRegion:
            regionCompDataObj[getPercentToRegionData(item.label)]?.toFixed(2) || 'N/A',
          percentToGaleAvg:
            regionCompDataObj[getPercentToGaleAvgData(item.label)]?.toFixed(2) || 'N/A',
        })),
        ...pivot_config_region_comp.calculatedPerformanceIndicators.map((item) => ({
          columnName: ' Calculated Performance Indicators',
          viewData: item.label,
          total: regionCompDataObj[item.value]?.toFixed(2) || 'N/A',
          percentToRegion:
            regionCompDataObj[getPercentToRegionData(item.label)]?.toFixed(2) || 'N/A',
          percentToGaleAvg:
            regionCompDataObj[getPercentToGaleAvgData(item.label)]?.toFixed(2) || 'N/A',
        })),
      ],
    };
  }
  return data;
};
